var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import "./card.styles.scss";
var Card = function (props) {
    var style = props.style, children = props.children, className = props.className;
    return (React.createElement("div", __assign({}, props, { style: style, className: "card-container " + (className ? className : "") }), children));
};
export default Card;
//# sourceMappingURL=card.js.map